import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { SxProps, Theme } from '@mui/material/styles';
import React from 'react';
import { Link } from 'react-router-dom';

export interface LinkListItemProps {
  /** The text to display in the list item */
  text: string;
  /** The icon to display in the list item */
  icon?: React.ReactNode;
  /** The path/URL to navigate to */
  to: string;
  /** Whether the ListItem should have disabled padding */
  disablePadding?: boolean;
  /** Custom styles for the ListItemButton */
  sx?: SxProps<Theme>;
  /** Custom styles for the ListItemIcon */
  iconSx?: SxProps<Theme>;
  /** Custom styles for the ListItem container */
  containerSx?: SxProps<Theme>;
  /** onClick handler (optional, for additional actions) */
  onClick?: () => void;
}

const defaultButtonStyles: SxProps<Theme> = {
  paddingLeft: '34px',
  textDecoration: 'none',
  color: 'inherit',
  '&:hover': {
    textDecoration: 'none'
  }
};

const defaultIconStyles: SxProps<Theme> = {
  minWidth: '45px'
};

export const LinkListItem: React.FC<LinkListItemProps> = ({
  text,
  icon,
  to,
  disablePadding = true,
  sx,
  iconSx,
  containerSx,
  onClick,
}) => {
  return (
    <ListItem disablePadding={disablePadding} sx={containerSx}>
      <ListItemButton
        component={Link}
        to={to}
        sx={{
          ...defaultButtonStyles,
          ...sx,
        }}
        onClick={onClick}
      >
        {icon && (
          <ListItemIcon sx={{
            ...defaultIconStyles,
            ...iconSx,
          }}>
            {icon}
          </ListItemIcon>
        )}
        <ListItemText primary={text} />
      </ListItemButton>
    </ListItem>
  );
};

export default LinkListItem;
